

import initmixin from "@/Services/initmixin";

export default {

  //mixins: [initmixin],
  // GET_CLIENTES CREAR_CLIENTES EDITAR_CLIENTES ELIMINAR_CLIENTES
  INFO: async function (data) {
    let url = '/citas/info/' + data.id
    return initmixin.formatrespuesta('get', data, url, true)
  },
  GET: async function (data) {
    let url = '/citas/ano/' + data.ano + '/mes/' + data.mes + '?cliente=' + data.cliente + '&vendedor=' + data.vendedor + (data.instalador ? '&instalador=' + data.instalador : '')
    return initmixin.formatrespuesta('get', data, url, true)
  },
  GET_INSTALADORES: async function (data) {
    let url = '/citas/instalacion/ano/' + data.ano + '/mes/' + data.mes + '?cliente=' + data.cliente + (data.instalador ? '&instalador=' + data.instalador : '')
    return initmixin.formatrespuesta('get', data, url, true)
  },




  REGISTRAR_FIRMA: async function (data) {
    let url = '/citas/firma/' + data.id
    return initmixin.formatrespuesta('post', data.data, url, true, true)
  },

  CREAR: async function (data) {
    let url = '/citas/'
    return initmixin.formatrespuesta('post', data, url, true)
  },


  EDITAR_FECHA: async function (data) {
    let url = '/citas/fecha/' + data.id
    return initmixin.formatrespuesta('put', data, url, true)
  },
  EDITAR: async function (data) {
    let url = '/citas/' + data.id
    return initmixin.formatrespuesta('put', data, url, true)
  },
  EDITAR_STATUS: async function (data) {
    let url = '/citas/status/' + data.id
    return initmixin.formatrespuesta('put', data, url, true)
  },
  EDITAR_GARANTIA: async function (data) {
    let url = '/citas/garantia/' + data.id
    return initmixin.formatrespuesta('put', data, url, true)
  },

  ELIMINAR: async function (data) {
    let url = '/citas/' + data.id
    return initmixin.formatrespuesta('delete', data, url, true)
  },

  getMetricosVendedores: async function (data) {
    let url = '/metricos_vendedores/calculo?ano=' + data.ano + '&mes=' + data.mes + (data.vendedor ? '&vendedor=' + data.vendedor : '')
    if (data.fecha_desde && data.fecha_hasta) {
      url += '&fecha_desde=' + data.fecha_desde + '&fecha_hasta=' + data.fecha_hasta
    }
    return initmixin.formatrespuesta('get', data, url, true)
  },

}